module.exports = __webpack_public_path__ + "img/comptage-24px-outline.c60e09fa.svg";